import { Button, Card, Chip, Divider, Stack, Typography } from '@healthinal/ui';
import { useState } from 'react';
import { TherapyDto } from '../../../../../api/generated/model';
import { formatDateWithGermanMonth } from '../../../../../utils/date.ts';
import { FileLink } from '../../../../components/FileLink.tsx';
import { CreateSupplementDialog } from './CreateSupplementDialog.tsx';

export function SupplementCard({ patientId, therapy }: { patientId: string; therapy: TherapyDto }) {
  const [isCreateIsolationDialogOpen, setIsCreateIsolationDialogOpen] = useState(false);

  return (
    <>
      <Card>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <Stack gap={1}>
            <Typography level="title-lg">Ergänzungsmeldung</Typography>
            {!therapy.supplementFileDetails ? (
              <Chip>Nicht erfasst</Chip>
            ) : (
              <Chip color={'success'} variant={'solid'}>
                Erfasst
              </Chip>
            )}
          </Stack>
          {!therapy.supplementFileDetails && (
            <Button color={'neutral'} onClick={() => setIsCreateIsolationDialogOpen(true)}>
              Ergänzungsmeldung erfassen
            </Button>
          )}
        </Stack>
        {therapy.supplementFileDetails && (
          <>
            <Divider />

            <Stack gap={2}>
              <Stack direction={'row'} gap={2}>
                <Typography flex={1} level={'title-sm'}>
                  Datum
                </Typography>
                <Typography flex={3} level={'title-sm'} alignSelf={'center'}>
                  {formatDateWithGermanMonth(therapy.supplementDate)}
                </Typography>
              </Stack>
              <Stack direction={'row'} gap={2}>
                <Typography flex={1} level={'title-sm'}>
                  Datei
                </Typography>
                <FileLink flex={3} fileDetails={therapy.supplementFileDetails} />
              </Stack>
            </Stack>
          </>
        )}
      </Card>
      <CreateSupplementDialog
        patientId={patientId}
        open={isCreateIsolationDialogOpen}
        onClose={() => setIsCreateIsolationDialogOpen(false)}
      />
    </>
  );
}
